import { Alert, Button, Card, Intent } from "@blueprintjs/core";
import { css } from "glamor";
import * as _ from "lodash";
import * as React from "react";
import { getAllFights, resetFight } from "src/api";
import { FightOverview } from "src/Interfaces";

const styles = {
	container: css({
		display: "flex",
		justifyContent: "center",
		flexWrap: "wrap",
	}),
	element: css({
		minWidth: "200px",
		margin: "20px",
		textAlign: "left",
	}),
	title: css({
		fontSize: "24px",
		marginBottom: "20px",
	}),
};

interface State {
	fights: FightOverview[];
	openAlert: number | undefined;
}
export default class FightResetter extends React.Component<{}, State> {
	public state = { fights: [] as FightOverview[], openAlert: undefined };

	public async componentDidMount() {
		const fights = await getAllFights();
		if (!fights) {
			return;
		}

		this.setState({ fights });
	}

	private handleResetFight(id: number) {
		this.setState({ openAlert: id });
	}
	private handleMoveConfirm(id: number): void {
		resetFight(id);
		this.setState({ openAlert: undefined });
	}
	private handleMoveCancel(): void {
		this.setState({ openAlert: undefined });
	}

	public render() {
		const fights = _.sortBy(this.state.fights, "name");
		return (
			<div {...styles.container}>
				{fights.map((fight) => (
					<Card key={fight.id} {...styles.element}>
						<div {...styles.title}>{fight.name}</div>
						<Button
							onClick={() => this.handleResetFight(fight.id)}
							text="Reset Fight"
							intent={Intent.DANGER}
						/>
						<Alert
							cancelButtonText="Cancel"
							confirmButtonText="Reset Fight"
							icon="trash"
							intent={Intent.DANGER}
							isOpen={this.state.openAlert === fight.id}
							onCancel={() => this.handleMoveCancel()}
							onConfirm={() => this.handleMoveConfirm(fight.id)}
							canEscapeKeyCancel={true}
							canOutsideClickCancel={true}
						>
							<p>
								Are you sure you want to reset <b>{fight.name}</b>? This cannot be undone!
							</p>
						</Alert>
					</Card>
				))}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Backend/FightResetter.tsx